import config from '../configs';

const initialState = {
  config,
};

export default (state = initialState) => state;
